import { Grid } from '@mui/material';
import MenuList from 'src/shared/components/navigations/menuList';
import { Colors } from 'src/shared/components/styles';

const DrawerNavigation = () => {
  return (
    <Grid
      sx={{
        pt: 0,
        height: 'auto',
        width: '100%',
        display: { lg: 'block', xs: 'none' },
        backgroundColor: Colors.WHITE,
        overflow: 'visible',
        pb: 2,
      }}
    >
      <MenuList />
    </Grid>
  );
};

export default DrawerNavigation;
